import { render, staticRenderFns } from "./grupostudio.vue?vue&type=template&id=b183b030&"
import script from "./grupostudio.vue?vue&type=script&lang=js&"
export * from "./grupostudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports